<template>
  <div class="page-container">
    <div class="table-wrapper">
      <div class="table-header">
        <span class="table-title">序列规则列表</span>
      <!--  <el-button v-auth="'business:seqConfig:save'" type="primary" size="small" @click="openAdd">新增序列</el-button> -->
      </div>
      <el-table :data="tableData" border v-loading="loading" style="width:100%;">
        <el-table-column prop="seqType" label="序列类型" width="110">
          <template slot-scope="scope">
            <el-tag type="primary" size="mini">{{ seqTypeLabel(scope.row.seqType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="startNum" label="起始号" width="120"></el-table-column>
        <el-table-column prop="currentNum" label="当前号" width="120"></el-table-column>
        <el-table-column prop="step" label="步长" width="70"></el-table-column>
        <el-table-column prop="length" label="长度" width="70"></el-table-column>
        <el-table-column prop="initialAmount" label="初始金额(USD)" width="130">
          <template slot-scope="scope">
            {{ scope.row.initialAmount != null && scope.row.initialAmount > 0 ? scope.row.initialAmount : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="170"></el-table-column>
        <el-table-column prop="createUser" label="创建人" width="100"></el-table-column>
        <el-table-column prop="updateUser" label="最后更新人" width="100"></el-table-column>
        <el-table-column prop="isDelete" label="状态" width="80">
          <template slot-scope="scope">
            <el-switch
              v-auth="'business:seqConfig:status'"
              :value="scope.row.isDelete === 1"
              @change="toggleStatus(scope.row)"
              active-color="var(--brand-primary)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button v-auth="'business:seqConfig:edit'" type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button v-auth="'business:seqConfig:delete'" type="text" size="small" style="color:#f56c6c;" @click="deleteRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="(v) => { pageSize = v; fetchList(); }"
        @current-change="(v) => { pageNum = v; fetchList(); }"
        :current-page="pageNum" :page-sizes="[10, 50, 100, 500]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <!-- ============ 新增/编辑弹窗 ============ -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="780px" :close-on-click-modal="false">
      <el-form label-position="top" size="small">
      <div class="seq-form-grid">
        <!-- 用户ID -->
        <div class="seq-type-card">
          <div class="seq-type-title">用户ID</div>
          <el-form-item label="起始号">
            <el-input-number v-model="form.user.startNum" :min="1" placeholder="如 16000001" style="width:100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="步长">
            <el-input-number v-model="form.user.step" :min="1" style="width:100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="长度">
            <el-input-number v-model="form.user.length" :min="1" :max="20" style="width:100%;" ></el-input-number>
          </el-form-item>
        </div>
        <!-- 钱包账号 -->
        <div class="seq-type-card">
          <div class="seq-type-title">钱包账号</div>
          <el-form-item label="起始号" required>
            <el-input-number v-model="form.wallet.startNum" :min="1" placeholder="如 56000001" style="width:100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="步长">
            <el-input-number v-model="form.wallet.step" :min="1" style="width:100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="长度">
            <el-input-number v-model="form.wallet.length" :min="1" :max="20" style="width:100%;"></el-input-number>
          </el-form-item>
        </div>
        <!-- 真实账号 -->
        <div class="seq-type-card">
          <div class="seq-type-title">真实账号</div>
          <el-form-item label="起始号" required>
            <el-input-number v-model="form.real.startNum" :min="1" placeholder="如 26000001" style="width:100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="步长">
            <el-input-number v-model="form.real.step" :min="1" style="width:100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="长度">
            <el-input-number v-model="form.real.length" :min="1" :max="20" style="width:100%;"></el-input-number>
          </el-form-item>
        </div>
        <!-- 模拟账号 -->
        <div class="seq-type-card">
          <div class="seq-type-title">模拟账号</div>
          <el-form-item label="起始号" required>
            <el-input-number v-model="form.demo.startNum" :min="1" placeholder="如 36000001" style="width:100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="步长">
            <el-input-number v-model="form.demo.step" :min="1" style="width:100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="长度">
            <el-input-number v-model="form.demo.length" :min="1" :max="20" style="width:100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="初始金额(USD)">
            <el-input-number v-model="form.demo.initialAmount" :min="0" :precision="2" style="width:100%;"></el-input-number>
          </el-form-item>
        </div>
      </div>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button v-auth="'business:seqConfig:edit'" type="primary" @click="saveAll">保存</el-button>
      </div>
    </el-dialog>

    <!-- ============ 新增序列弹窗（单条新增，序列类型不可重复） ============ -->
    <el-dialog title="新增序列" :visible.sync="addVisible" width="460px" :close-on-click-modal="false">
      <el-form label-position="top" size="small">
        <el-form-item label="序列类型" required>
          <el-select v-model="addForm.seqType" placeholder="请选择序列类型" style="width:100%;">
            <el-option
              v-for="t in seqTypeOptions"
              :key="t.type"
              :label="t.label"
              :value="t.type"
              :disabled="t.used">
              <span>{{ t.label }}</span>
              <span v-if="t.used" class="seq-type-used">已配置</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始号" required>
          <el-input-number v-model="addForm.startNum" :min="1" placeholder="如 16000001" style="width:100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="步长">
          <el-input-number v-model="addForm.step" :min="1" style="width:100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="长度">
          <el-input-number v-model="addForm.length" :min="1" :max="20" style="width:100%;"></el-input-number>
        </el-form-item>
        <!-- 初始金额仅模拟账号有效（与编辑弹窗、t_account_seq_config.initial_amount 口径一致） -->
        <el-form-item v-if="addForm.seqType === 4" label="初始金额(USD)">
          <el-input-number v-model="addForm.initialAmount" :min="0" :precision="2" style="width:100%;"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button v-auth="'business:seqConfig:save'" type="primary" :loading="addSubmitting" @click="submitAdd">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { seqConfigList, seqConfigSaveAll, seqConfigDeleteBatchIds, seqConfigStatus, seqConfigAdd } from '@/api/seqConfig'

const SEQ_TYPES = [
  { key: 'user', type: 1, seqKey: 'user_seq' },
  { key: 'wallet', type: 2, seqKey: 'wallet_seq' },
  { key: 'real', type: 3, seqKey: 'real_seq' },
  { key: 'demo', type: 4, seqKey: 'demo_seq' }
]

const SEQ_TYPE_LABELS = { 1: '用户ID', 2: '钱包账号', 3: '真实账号', 4: '模拟账号' }

function emptyAddForm() {
  return { seqType: null, startNum: null, step: 1, length: 8, initialAmount: 10000 }
}

function emptyForm() {
  return {
    user: { id: null, startNum: null, step: 1, length: 8, initialAmount: 0 },
    wallet: { id: null, startNum: null, step: 1, length: 8, initialAmount: 0 },
    real: { id: null, startNum: null, step: 1, length: 8, initialAmount: 0 },
    demo: { id: null, startNum: null, step: 1, length: 8, initialAmount: 10000 }
  }
}

export default {
  name: 'SeqConfigList',
  data() {
    return {
      tableData: [], loading: false,
      pageNum: 1, pageSize: 10, total: 0,
      dialogVisible: false, dialogTitle: '新增序列规则', editing: false,
      form: emptyForm(),
      // 单条新增
      addVisible: false, addSubmitting: false, addForm: emptyAddForm()
    }
  },
  computed: {
    /**
     * 新增弹窗的类型下拉：已配置过的类型（含已禁用，后端同样拦截）置灰不可选，
     * 避免选完提交才被后端拒绝
     */
    seqTypeOptions() {
      const used = this.tableData.map(r => r.seqType)
      return SEQ_TYPES.map(t => ({
        type: t.type,
        label: SEQ_TYPE_LABELS[t.type],
        used: used.indexOf(t.type) > -1
      }))
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      this.loading = true
      seqConfigList({ pageNum: this.pageNum, pageSize: this.pageSize }).then(res => {
        if (res.code === 0) {
          this.tableData = res.result.list || []
          this.total = res.result.total || 0
        }
      }).finally(() => { this.loading = false })
    },

    seqTypeLabel(t) {
      return SEQ_TYPE_LABELS[t] || t
    },

    openAdd() {
      this.addForm = emptyAddForm()
      this.addVisible = true
    },

    submitAdd() {
      if (!this.addForm.seqType) {
        this.$message.warning('请选择序列类型')
        return
      }
      if (!this.addForm.startNum) {
        this.$message.warning('请输入起始号')
        return
      }
      this.addSubmitting = true
      seqConfigAdd({
        seqType: this.addForm.seqType,
        startNum: this.addForm.startNum,
        currentNum: this.addForm.startNum,
        step: this.addForm.step || 1,
        length: this.addForm.length || 8,
        // 初始金额仅模拟账号有效，其余类型固定 0
        initialAmount: this.addForm.seqType === 4 ? (this.addForm.initialAmount || 0) : 0
      }).then(res => {
        if (res.code === 0) {
          this.$message.success('新增成功')
          this.addVisible = false
          this.fetchList()
        }
      }).catch(() => {
        // 序列类型重复等业务错误由响应拦截器统一弹出后端 message，这里不再重复提示
      }).finally(() => { this.addSubmitting = false })
    },

    openEdit(row) {
      this.editing = true
      this.dialogTitle = '编辑序列规则'
      // 从 tableData 中取出全部4种类型当前值回填
      this.form = {
        user: this.buildSeqField(1),
        wallet: this.buildSeqField(2),
        real: this.buildSeqField(3),
        demo: this.buildSeqField(4)
      }
      this.dialogVisible = true
    },

    /** 从 tableData 中取指定 seqType 的当前值 */
    buildSeqField(seqType) {
      const row = this.tableData.find(r => r.seqType === seqType)
      if (row) {
        return {
          id: row.id,
          startNum: row.startNum,
          step: row.step,
          length: row.length,
          initialAmount: row.initialAmount || 0
        }
      }
      return { id: null, startNum: null, step: 1, length: 8, initialAmount: 0 }
    },

    saveAll() {
      const configs = []
      SEQ_TYPES.forEach(t => {
        const data = this.form[t.key]
        if (data.startNum) {
          configs.push({
            id: data.id || null,
            seqType: t.type,
            seqKey: t.seqKey,
            startNum: data.startNum,
            currentNum: data.startNum,
            step: data.step || 1,
            length: data.length || 8,
            initialAmount: data.initialAmount || 0
          })
        }
      })

      if (configs.length === 0) {
        this.$message.warning('请至少填写一个类型的起始号')
        return
      }

      seqConfigSaveAll({ configs: configs }).then(res => {
        if (res.code === 0) {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.fetchList()
        }
      }).catch(() => {
        this.$message.error('保存失败，请检查网络连接')
      })
    },

    deleteRow(row) {
      this.$confirm('确定删除该序列规则吗？', '提示', { type: 'warning' }).then(() => {
        seqConfigDeleteBatchIds(String(row.id)).then(res => {
          if (res.code === 0) {
            this.$message.success('删除成功')
            this.fetchList()
          }
        })
      }).catch(() => {})
    },

    toggleStatus(row) {
      const newStatus = row.isDelete === 1 ? 2 : 1
      seqConfigStatus(row.id, newStatus).then(res => {
        if (res.code === 0) {
          this.$message.success('状态更新成功')
          this.fetchList()
        }
      })
    }
  }
}
</script>

<style scoped>
.page-container { padding: 20px; }
.table-wrapper { background: #fff; border-radius: 4px; padding: 16px; }
.table-header { margin-bottom: 12px; display: flex; align-items: center; }
.table-title { font-size: 15px; font-weight: 600; color: #303133; flex: 1; }
/* 新增弹窗类型下拉里「已配置」的灰色尾注 */
.seq-type-used { float: right; color: #c0c4cc; font-size: 12px; }
.seq-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.seq-type-card {
  border: 1px solid #e4e7ed; border-radius: 8px; padding: 16px;
}
.seq-type-title { font-weight: 600; font-size: 14px; margin-bottom: 12px; color: #303133; }
</style>
